import { recordInteractionForSession, initiateLoggingSession } from "../../services/MainService";

const state = {
  sessionID: undefined,
  expiry: undefined,
  experiments: undefined
};

const mutations = {
    setSessionID(state, sessionID, ttl = 2) {
        const now = new Date();
        state.sessionID = sessionID;
        state.expiry = now.getTime() + (ttl * 3600000);
        console.log("Setting Session ID in Vuex")
        console.log(sessionID)
    },
    setExperiments(state, experiments) {
        state.experiments = experiments;
        console.log("Setting Experiments in Vuex")
        console.log(experiments)
    }
}

const actions = {
    async recordInteraction(state, interactionData) {
        // check if sessionID already set, if not => retrieve one and set it
        if (state.state.sessionID === undefined){
            const browserInformation = {
                browserName: navigator.appName,
                browserVersion: navigator.appVersion,
                currentLanguage: navigator.language,
                browserLanguages: navigator.languages,
                userAgent: navigator.userAgent,
                cookiesEnabled: navigator.cookieEnabled,
                doNotTrackPreference: navigator.doNotTrack,
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight
            };
            const requestInformation = {
                referer: document.referrer,
                fullURL: document.URL
            };
            let contextInformation = {};
            // if forceExperiment is set => include in contextInformation
            if ("forceExperiment" in interactionData.eventData){
                contextInformation.forceExperiment = interactionData.eventData.forceExperiment;
            }
            const loggingResult = await initiateLoggingSession(browserInformation, contextInformation, requestInformation);
            if (loggingResult.success === true){
                state.commit("setSessionID", loggingResult.data.sessionID);
                state.commit("setExperiments", loggingResult.data.experiments);
            }
        }

        // record interaction
        recordInteractionForSession(state.state.sessionID, interactionData.eventType, interactionData.eventData);

        //Google Analytics Data Tracking
        //Map the event based on the interactiondata-Object
        try {
            const eventTypeMapping = {
                "interfaceInteraction": "interfaceInteraction_" + interactionData.eventData.source + "_" + interactionData.eventData.type + "_" + interactionData.eventData.selection,
                "nextStepInProviderFinder": "nextStepInProviderFinder_" + interactionData.eventData.step,
                "searchbarClicked": "searchbarClicked_" + interactionData.eventData.source,
                "newInquiryPlaced": "ads_conversion_Termin_vereinbaren_1",
                "newNewsletterRegistration": "newNewsletterRegistration" + "_" + interactionData.eventData.source,
                "newFileUploaded": "newFileUploaded_" + interactionData.eventData.typeOfFile,
                "testimonialsSwiped": "testimonialsSwiped_" + interactionData.eventData.source + "_" + interactionData.eventData.direction,
                "cartOpened": "cartOpened_" + interactionData.eventData.source
              }
    
            //Send the custom-mapped string to google analytics
            const eventString = eventTypeMapping[interactionData.eventType] || interactionData.eventType + "_" + interactionData.eventData.source + "_" + interactionData.eventData.type;
            this._vm.$gtag.event(eventString);   
        } catch (error) {
            console.log("Error during GA Event")
            console.log(error)
        }        
    }
}

export default {
  state,
  mutations,
  actions
};
